import _ from 'lodash';
import moment from 'moment-timezone';
import Entity from './Entity';

const fieldsWithDynamicAllowedValues = {
  status: { enumName: 'PaymentApplicationMonthStatusEnum'}
};

const fieldsWithStaticAllowedValues = {
  month: {
    options: [
      { value: 'Jan', label: 'January' },
      { value: 'Feb', label: 'February' },
      { value: 'Mar', label: 'March' },
      { value: 'Apr', label: 'April' },
      { value: 'May', label: 'May' },
      { value: 'Jun', label: 'June' },
      { value: 'Jul', label: 'July' },
      { value: 'Aug', label: 'August' },
      { value: 'Sep', label: 'September' },
      { value: 'Oct', label: 'October' },
      { value: 'Nov', label: 'November' },
      { value: 'Dec', label: 'December' },
    ]
  }
};

export default class PaymentApplicationMonth {
  fields = {
    id: {
      value: null
    },
    facility_id: {
      value: null
    },
    month: {
      value: null
    },
    year: {
      value: null
    },
    status: {
      value: null
    },
  };

  static createWithDefaults(facilityId, month, year) {
    const paymentApplicationMonth = new this();
    paymentApplicationMonth.fields.facility_id.value = facilityId;
    paymentApplicationMonth.fields.month.value = month;
    paymentApplicationMonth.fields.year.value = year;
    paymentApplicationMonth.fields.status.value = 'OPEN'

    return paymentApplicationMonth;
  }

  static createDefaultYearOfMonths(facilityId) {
    const numMonths = 12;

    return [...new Array(numMonths)].map((_, i) => {
      const monthMoment = moment().subtract(i+1, 'months');
      const month = monthMoment.format('MMM');
      const year = monthMoment.format('YYYY');

      return PaymentApplicationMonth.createWithDefaults(facilityId, month, year);
    });
  }

  static createFromQueryValues(values) {
    const paymentApplicationMonth = new this();

    for (const field in paymentApplicationMonth.fields) {
      if (values.hasOwnProperty(field)) { 
        paymentApplicationMonth.fields[field].value = values[field];            
      }
    }

    return paymentApplicationMonth;
  }

  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      fieldsWithStaticAllowedValues,
      fieldsWithDynamicAllowedValues,
      fields
    );
  }

  getQueryFieldValues() {
    const values = _.cloneDeep(PaymentApplicationMonthInput);

    for (let field in values) {
      if (this.fields[field].value !== null) {
        values[field] = this.fields[field].value;
      }
    }
    return values;
  }
}


export const PaymentApplicationMonthInput = {
  id: null,
  facility_id: null,
  month: null,
  year: null,
  status: null,
}
